import React, { ReactNode, useState } from 'react';
import { Check } from 'lucide-react';

import styles from './SuccessMessage.module.scss';

export type SuccessMessageProps = { message: ReactNode };

const SuccessMessage = ({ message }: SuccessMessageProps) => {
    const [hasDismissed, setDismissed] = useState(false);

    if (hasDismissed) {
        return null;
    }

    return (
        <div className={styles.successMessage}>
            <Check />
            <div className={styles.message} data-testid='message'>
                {message}
            </div>
            &nbsp;
            <div className={styles.dismiss} onClick={() => setDismissed(true)}>
                Dismiss
            </div>
        </div>
    );
};

export default SuccessMessage;
